<template>
  <HeaderContent title="Cleaning" />
  <ActionContent
    :cta="false"
    ctaText="Cleaning"
    :filterDate="true"
    v-model:startDate="startDate"
    v-model:endDate="endDate"
    v-model:search="search"
    @action="modal = !modal"
    @showFilter="modalFilter = !modalFilter"
    @search-query="searchData"
  >
    <template #left-filters>
      <div class="text-left w-100" style="min-width: 200px;">
        <label class="">Done By</label>
        <BFormSelect v-model="selectedEmployeeUuid" :options="employeeOptions" />
      </div>
    </template>
  </ActionContent>

  <CleaningStatistics title="Cleaning Statistics" :data="statistics" />
  <CleaningForm :modal="modal" @update:modal="updateModal" />

  <!-- Modal untuk Cleaning Finish Confirmation -->
  <CleaningConfirm
    title="Cleaning Finish Confirmation"
    v-model="modalTime"
    @confirmed="saveFinish"
  >
    <template #text>
      <div class="cleaning-confirmation">
        <!-- Room Information Section -->
        <div class="info-section">
          <h6>Room Information</h6>
          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Room Number</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ activeRow?.no_room || "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Room Type</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ activeRow?.type_room || "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Date</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ activeRow?.date || "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Done By</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ activeRow?.housekeeping || "-" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Cleaning Details Section -->
        <div class="info-section">
          <h6>Cleaning Details</h6>

          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Start Time</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ startTime || "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">End Time</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ endTime || "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">Duration</td>
                <td class="text-left pr-2">:</td>
                <td class="text-left fw-semibold">
                  {{ duration || "-" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Remarks Section -->
        <div class="form-section">
          <h6>Additional Information</h6>
          <BFormGroup label="Remarks (Optional)" label-for="remarks-input">
            <BFormTextarea
              id="remarks-input"
              v-model="remarks"
              placeholder="Enter any remarks or notes about the cleaning process..."
              rows="3"
            />
          </BFormGroup>
        </div>
      </div>
    </template>
  </CleaningConfirm>

  <CleaningDataTable
    :data="filterDataCleanings"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  >
    <template #custom-foot>
      <template v-if="['superadmin', 'backoffice', 'supervisor'].includes(user?.role)">
        <BTr v-for="(rc, i) in commissionRecap" :key="i">
          <BTh class="text-right align-middle pe-3" style="text-align: right; background-color: #f8f9fa;"></BTh>
          <BTh  class="text-right align-middle pe-3" style="text-align: right; background-color: #f8f9fa;">{{ rc.type_room }} :</BTh>
          <BTd class="text-right align-middle bg-white" style="text-align: right; width: 100px;">{{ rc.count }} room</BTd>
          <BTd class="text-right align-middle bg-white" style="text-align: right; width: 150px;">x {{ formatIDR(rc.commission) }}</BTd>
          <BTd class="text-right fw-bold align-middle bg-white" style="text-align: right; width: 150px;">{{ formatIDR(rc.subtotal) }}</BTd>
          <BTd :colspan="headers.length - 3" class="text-right fw-bold align-middle bg-white" style="text-align: right; width: 150px;"></BTd>
        </BTr>
        <BTr v-if="commissionRecap.length > 0">
          <BTh class="text-right align-middle pe-3" style="text-align: right; background-color: #f8f9fa;"></BTh>
          
          <BTh  class="text-right align-middle pe-3" style="text-align: right; background-color: #f8f9fa;">Total :</BTh>
          <BTd class="text-right fw-bold align-middle bg-white" style="text-align: right;">{{ totalRecapCount }} room</BTd>
          <BTd class="bg-white"></BTd>
          <BTd class="text-right fw-bold align-middle bg-white" style="text-align: right;">{{ formatIDR(totalRecapAmount) }}</BTd>
          <BTd :colspan="headers.length - 3" class="text-right fw-bold align-middle bg-white" style="text-align: right; width: 150px;"></BTd>
        </BTr>
      </template>
    </template>
  </CleaningDataTable>
</template>

<script>
import { inject, ref, onMounted, computed, watch } from "vue";
import { BFormGroup, BFormTextarea, BFormSelect, BTr, BTh, BTd } from "bootstrap-vue-next";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CleaningForm from "./CleaningForm.vue";
import CleaningConfirm from "@/components/ModalDialog.vue";
import CleaningStatistics from "@/components/StatisticData.vue";
import CleaningDataTable from "@/components/DataTable.vue";
import iconCleaning from "../../../../public/icons/brush-cleaning.svg";
import iconFinish from "../../../../public/icons/hand-cleaning.svg";
import iconOngoing from "../../../../public/icons/arrow-comparison.svg";
import { formatIDR } from "@/utils/currency";

export default {
  name: "CleaningIndex",
  components: {
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BTr,
    BTh,
    BTd,
    HeaderContent,
    ActionContent,
    CleaningStatistics,
    CleaningForm,
    CleaningConfirm,
    CleaningDataTable,
  },
  setup() {
    const repositories = inject("repositories");
    const scheduleRepository = repositories?.schedule;
    const cleaningRepository = repositories?.cleaning;
    const employeeRepository = repositories?.employee;

    const startDate = ref("");
    const endDate = ref("");
    const selectedEmployeeUuid = ref(null);
    const employeeOptions = ref([{ value: null, text: 'All Housekeeping' }]);

    const cleanings = ref([]);
    const modal = ref(false);
    const modalTime = ref(false);
    const modalFilter = ref(false);
    const currentPage = ref(1);
    const isSaving = ref(false);

    const activeRow = ref(null);
    const startTime = ref(null);
    const endTime = ref(null);
    const duration = ref(null);
    const remarks = ref("");
    const search = ref("");
    const user = ref({});

    const headers = computed(() => {
      const base = [
        { key: "no", label: "#" },
        { key: "no_room", label: "Room Number", sortable: true },
        { key: "type_room", label: "Room Type", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "start_time", label: "Start Time", sortable: true },
        { key: "end_time", label: "End Time", sortable: true },
        { key: "duration", label: "Duration", sortable: true },
        { key: "housekeeping", label: "Done By", sortable: true },
        { key: "remarks", label: "Remarks", sortable: true },
      ];

      if (['superadmin', 'backoffice', 'supervisor'].includes(user.value?.role)) {
        base.push({ 
          key: "commission", 
          label: "Fee", 
          sortable: true,
          formatter: (value, key, item) => {
            if (item.status_cleaning === "finish") {
              return formatIDR(value || 0);
            }
            return "-";
          }
        });
      }

      base.push({ key: "action", label: "Actions" });

      return base;
    });

    // Fungsi untuk menghitung durasi
    const calculateDuration = (startTime, endTime) => {
      const [sh, sm] = startTime.split(":").map(Number);
      const [eh, em] = endTime.split(":").map(Number);
      let totalMinutes = eh * 60 + em - (sh * 60 + sm);

      if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }

      if (totalMinutes >= 60) {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${hours} jam ${minutes} menit`;
      } else {
        return `${totalMinutes} menit`;
      }
    };

    // Fungsi untuk update item secara lokal tanpa reload semua data
    const updateLocalItem = (scheduleUuid, roomUuid, updates) => {
      const index = cleanings.value.findIndex(
        (item) =>
          item.schedule_uuid === scheduleUuid && item.room_uuid === roomUuid
      );

      if (index !== -1) {
        cleanings.value[index] = {
          ...cleanings.value[index],
          ...updates,
        };
      }
    };

    const customActions = computed(() => [
      {
        label: (item) =>
          item.status_cleaning === "start"
            ? "Finish"
            : item.status_cleaning === "finish"
            ? "Done"
            : "Start",

        icon: "fas fa-stopwatch",
        variant: (item) =>
          item.status_cleaning === "start"
            ? "danger"
            : item.status_cleaning === "finish"
            ? "secondary"
            : "success",

        action: async (item) => {
          console.log("Action clicked for item:", item);

          if (item.status_cleaning === "finish") {
            console.log("Item is already finished, no action needed");
            return;
          }

          const now = new Date();
          const currentTime = now.toTimeString().slice(0, 5);

          if (item.status_cleaning === "idle") {
            // START CLEANING - Update UI immediately
            updateLocalItem(item.schedule_uuid, item.room_uuid, {
              status_cleaning: "start",
              start_time: currentTime,
            });

            try {
              // Then call API in background
              await cleaningRepository.start({
                schedule_uuid: item.schedule_uuid,
                room_uuid: item.room_uuid,
                start_time: currentTime,
              });

              console.log("Cleaning started successfully");
            } catch (error) {
              console.error("Error starting cleaning:", error);
              // Revert local state if API fails
              updateLocalItem(item.schedule_uuid, item.room_uuid, {
                status_cleaning: "idle",
                start_time: "-",
              });
            }
          } else if (item.status_cleaning === "start") {
            // FINISH CLEANING - Prepare modal data immediately
            const start = item.start_time;

            if (!start || start === "-" || !start.includes(":")) {
              console.warn("Start time is invalid. Cannot proceed to finish.");
              return;
            }

            // Set all modal data immediately
            startTime.value = start;
            endTime.value = currentTime;
            activeRow.value = item;
            duration.value = calculateDuration(start, currentTime);

            // Show modal immediately
            modalTime.value = true;
          }
        },

        disabled: (item) =>
          item.status_cleaning === "finish" || isDisabled(item),
      },
    ]);

    const statisticsCleanings = computed(() => {
      const notStartedCount = cleanings.value.filter(
        (item) => item.status_cleaning === "idle"
      ).length;
      const ongoingCount = cleanings.value.filter(
        (item) => item.status_cleaning === "start"
      ).length;
      const finishedCount = cleanings.value.filter(
        (item) => item.status_cleaning === "finish"
      ).length;

      return {
        notStartedCount,
        ongoingCount,
        finishedCount,
      };
    });

    const statistics = computed(() => [
      {
        label: "Total",
        key: "Not Started",
        value: statisticsCleanings.value.notStartedCount,
        color: "primary",
        icon: iconCleaning,
      },
      {
        label: "Total",
        key: "Ongoing",
        value: statisticsCleanings.value.ongoingCount,
        color: "primary",
        icon: iconOngoing,
      },
      {
        label: "Total",
        key: "Finished",
        value: statisticsCleanings.value.finishedCount,
        color: "primary",
        icon: iconFinish,
      },
    ]);

    // Fungsi untuk mendapatkan data cleaning dari API
    const getCleaningData = async (params) => {
      try {
        const cleaningRes = await cleaningRepository.getAll(params);
        console.log("Raw cleaning API response with search:", cleaningRes);
        return cleaningRes.data || { data: [], commission: [] };
      } catch (error) {
        console.error("Error fetching cleaning data:", error);
        return { data: [], commission: [] };
      }
    };

    // Fungsi untuk menentukan status cleaning berdasarkan data yang ada
    const determineCleaningStatus = (cleaningData) => {
      if (!cleaningData || Object.keys(cleaningData).length === 0) {
        return "idle";
      }

      const { start_time, end_time } = cleaningData;

      const isValidTime = (time) => {
        return (
          time &&
          time !== "-" &&
          time !== "" &&
          time !== null &&
          time !== undefined &&
          time !== "null"
        );
      };

      if (isValidTime(start_time) && isValidTime(end_time)) {
        return "finish";
      }

      if (isValidTime(start_time)) {
        return "start";
      }

      return "idle";
    };

    // Fungsi untuk mencari data cleaning berdasarkan room_uuid, employee, dan tanggal
    const findCleaningDataForRoom = (
      cleaningDataArray,
      roomUuid,
      employee_uuid,
      scheduleDate,
      scheduleUuid
    ) => {
      console.log(`Searching cleaning data for:`, {
        roomUuid,
        employee_uuid,
        scheduleDate,
        scheduleUuid,
      });

      // Prioritas pencarian (STRICT):
      // 1. Berdasarkan schedule_uuid dan room_uuid (paling akurat)
      // 2. Berdasarkan room_uuid, employee, dan EXACT tanggal yang sama
      // 3. TIDAK ada fallback - jika tidak ada yang cocok, return null

      let foundCleaning = null;

      // Prioritas 1: Cari berdasarkan schedule_uuid dan room_uuid
      for (const cleaning of cleaningDataArray) {
        if (
          cleaning.schedule_uuid === scheduleUuid &&
          cleaning.room_uuid === roomUuid
        ) {
          console.log(`Found by schedule_uuid + room_uuid:`, cleaning);
          foundCleaning = cleaning;
          break;
        }
      }

      // Prioritas 2: Jika tidak ditemukan, cari berdasarkan room, employee, dan EXACT date
      if (!foundCleaning) {
        for (const cleaning of cleaningDataArray) {
          // Skip jika tidak ada room_uuid
          if (cleaning.room_uuid !== roomUuid) continue;

          // Cek apakah employee sama
          const isSameEmployee =
            cleaning.employee_uuid === employee_uuid ||
            cleaning.employee?.uuid === employee_uuid;

          // Cek apakah tanggal EXACTLY sama (lebih strict)
          let isSameDate = false;

          // Cek berbagai format tanggal yang mungkin ada di data cleaning
          if (cleaning.schedule_date === scheduleDate) {
            isSameDate = true;
          } else if (cleaning.created_at) {
            // Extract tanggal dari created_at (format: YYYY-MM-DD HH:mm:ss)
            const cleaningDate = cleaning.created_at.split(" ")[0]; // Ambil bagian tanggal saja
            isSameDate = cleaningDate === scheduleDate;
          } else if (cleaning.date === scheduleDate) {
            isSameDate = true;
          }

          console.log(`Checking cleaning record:`, {
            cleaning_id: cleaning.id || cleaning.uuid,
            room_match: cleaning.room_uuid === roomUuid,
            employee_match: isSameEmployee,
            date_match: isSameDate,
            cleaning_date:
              cleaning.schedule_date || cleaning.created_at || cleaning.date,
            target_date: scheduleDate,
          });

          // HANYA ambil jika SEMUA kondisi terpenuhi (room + employee + exact date)
          if (isSameEmployee && isSameDate) {
            console.log(`Found by room + employee + exact date:`, cleaning);
            foundCleaning = cleaning;
            break;
          }
        }
      }

      if (!foundCleaning) {
        console.log(
          `No cleaning data found for room ${roomUuid} on date ${scheduleDate}`
        );
      }

      return foundCleaning;
    };

    const getAll = async (searchQuery = "") => {
      const params = {};

      if (searchQuery) params.search = searchQuery;
      if (startDate.value) params.start_date = startDate.value;
      if (endDate.value) params.end_date = endDate.value;
      if (selectedEmployeeUuid.value) params.employee_uuid = selectedEmployeeUuid.value;

      if (user.value.role === "housekeeping") {
        params.employee_uuid = user.value.employee_uuid;
      }

      try {
        const [scheduleRes, cleaningResData] = await Promise.all([
          scheduleRepository.getAll(params),
          getCleaningData(params),
        ]);

        const cleaningDataArray = cleaningResData.data || [];

        console.log("Schedule data:", scheduleRes.data?.data);
        console.log("Cleaning data array:", cleaningDataArray);

        const tempData = [];

        if (scheduleRes.data?.data) {
          scheduleRes.data.data.forEach((item) => {
            const staffName = item.employee?.fullname ?? "-";
            const employee_uuid = item.employee?.uuid;
            const scheduleDate = item.schedule ?? "-";

            item.room_category?.forEach((category) => {
              const roomType = category?.name ?? "-";

              category.rooms?.forEach((room) => {
                // Cari data cleaning yang sesuai untuk room ini
                const cleaningData =
                  findCleaningDataForRoom(
                    cleaningDataArray,
                    room.uuid,
                    employee_uuid,
                    scheduleDate,
                    item.uuid // tambahkan schedule_uuid
                  ) || {};

                console.log(
                  `Room ${room.code} (${scheduleDate}) - Found cleaning data:`,
                  cleaningData
                );

                const status_cleaning = determineCleaningStatus(cleaningData);

                const formatTime = (time) => {
                  if (!time || time === null || time === "null") return "-";
                  return time.length > 5 ? time.substring(0, 5) : time;
                };

                tempData.push({
                  no_room: room?.code ?? "-",
                  type_room: roomType,
                  date: scheduleDate,
                  housekeeping: staffName,
                  start_time: formatTime(cleaningData.start_time),
                  end_time: formatTime(cleaningData.end_time),
                  duration: cleaningData.duration ?? "-",
                  remarks: cleaningData.remarks ?? "-",
                  commission: cleaningData.commission ? cleaningData.commission : (category.housekeeping_commission ?? 0),
                  uuid: cleaningData.uuid ?? null,
                  schedule_uuid: item.uuid,
                  room_uuid: room.uuid,
                  employee_uuid: employee_uuid,
                  status_cleaning,
                  // Simpan data cleaning asli untuk referensi
                  original_cleaning_data: cleaningData,
                });
              });
            });
          });
        }

        cleanings.value = tempData.map((item, index) => ({
          no: index + 1,
          ...item,
        }));

        console.log("Final cleaning data:", cleanings.value);
      } catch (err) {
        console.error("Failed to fetch cleaning data:", err);
      }
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
    };

    const resetModal = () => {
      remarks.value = "";
      activeRow.value = null;
      startTime.value = null;
      endTime.value = null;
      duration.value = null;
      isSaving.value = false;
    };

    const saveFinish = async () => {
      if (!activeRow.value) {
        console.error("No active row found");
        return;
      }

      isSaving.value = true;

      // Update local state immediately for better UX
      updateLocalItem(
        activeRow.value.schedule_uuid,
        activeRow.value.room_uuid,
        {
          status_cleaning: "finish",
          end_time: endTime.value,
          duration: duration.value,
          remarks: remarks.value || "-",
        }
      );

      try {
        await cleaningRepository.finish({
          schedule_uuid: activeRow.value.schedule_uuid,
          room_uuid: activeRow.value.room_uuid,
          end_time: endTime.value,
          duration: duration.value,
          remarks: remarks.value || "-",
        });

        console.log("Cleaning finished successfully");

        // Close modal and reset
        modalTime.value = false;
        resetModal();
      } catch (error) {
        console.error("Error finishing cleaning:", error);

        // Revert local state if API fails
        updateLocalItem(
          activeRow.value.schedule_uuid,
          activeRow.value.room_uuid,
          {
            status_cleaning: "start",
            end_time: "-",
            duration: "-",
            remarks: "-",
          }
        );

        modalTime.value = false;
      } finally {
        isSaving.value = false;
      }
    };

    function handleSearch(query) {
      search.value = query;
      getAll(query);
    }

    const searchData = async (keyword) => {
      getAll(keyword);
    };

    const fetchEmployees = async () => {
      try {
        const res = await employeeRepository.getHousekeeping();
        const data = res.data?.data || [];
        employeeOptions.value = [
          { value: null, text: 'All Housekeeping' },
          ...data.map(emp => ({ value: emp.uuid, text: emp.fullname }))
        ];
      } catch (e) {
        console.error(e);
      }
    };

    watch([startDate, endDate, selectedEmployeeUuid], () => {
      getAll(search.value);
    });

    onMounted(() => {
      const dataUser = localStorage.getItem("user");
      if (dataUser) {
        user.value = JSON.parse(dataUser);
        console.log("data user :", user);
      }

      fetchEmployees();
      getAll();
    });
    const isDisabled = (item) => {
      return user.value.employee_uuid !== item.employee_uuid;
    };

    const filterDataCleanings = computed(() => {
      const isHousekeeping = user.value.role === "housekeeping";

      if (isHousekeeping) {
        // show cleaning data which related with cleaning data user login
        return cleanings.value.filter(
          (item) => item.employee_uuid === user.value.employee_uuid
        );
      }

      // other than housekeeping, show all cleanings data
      return cleanings.value;
    });

    const commissionRecap = computed(() => {
      const recapMap = {};

      filterDataCleanings.value.forEach(item => {
         if (item.status_cleaning === "finish") {
            const categoryName = item.type_room;
            const commissionValue = Number(item.commission) || 0;
            const key = `${categoryName}_${commissionValue}`;

            if (!recapMap[key]) {
               recapMap[key] = {
                  type_room: categoryName,
                  count: 0,
                  commission: commissionValue,
                  subtotal: 0
               };
            }
            recapMap[key].count += 1;
            recapMap[key].subtotal += commissionValue;
         }
      });

      return Object.values(recapMap);
    });


    const totalRecapCount = computed(() => {
        return commissionRecap.value.reduce((sum, item) => sum + item.count, 0);
    });

    const totalRecapAmount = computed(() => {
        return commissionRecap.value.reduce((sum, item) => sum + item.subtotal, 0);
    });

    return {
      formatIDR,
      startDate,
      endDate,
      selectedEmployeeUuid,
      employeeOptions,
      commissionRecap,
      totalRecapCount,
      totalRecapAmount,
      user,
      isDisabled,
      cleanings,
      filterDataCleanings,
      headers,
      modal,
      modalTime,
      modalFilter,
      currentPage,
      customActions,
      statistics,
      startTime,
      endTime,
      duration,
      remarks,
      activeRow,
      isSaving,
      saveFinish,
      getAll,
      updateModal,
      search,
      handleSearch,
      searchData,
      resetModal,
    };
  },
};
</script>

<style scoped>
/* Styling untuk modal cleaning confirmation */
.cleaning-confirmation {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}

.info-section {
  margin-bottom: 24px;
}

.info-section h6 {
  color: #666;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.info-grid {
  /* display: grid; */
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.info-item strong {
  color: #333;
  font-weight: 500;
  min-width: 120px;
  margin-right: 8px;
}

.form-section {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.form-section h6 {
  color: #666;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

/* Responsive untuk mobile */
@media (max-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-item strong {
    min-width: auto;
    margin-bottom: 2px;
  }
}

/* Form styling */
.form-group label {
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}

.form-control:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
</style>
